import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 16,
		cy: 16,
		r: 15,
		stroke: "#CCCFD8",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.2929 18.2929C11.9024 18.6834 11.9024 19.3166 12.2929 19.7071C12.6834 20.0976 13.3166 20.0976 13.7071 19.7071L12.2929 18.2929ZM19.7071 13.7071C20.0976 13.3166 20.0976 12.6834 19.7071 12.2929C19.3166 11.9024 18.6834 11.9024 18.2929 12.2929L19.7071 13.7071ZM18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L18.2929 19.7071ZM13.7071 12.2929C13.3166 11.9024 12.6834 11.9024 12.2929 12.2929C11.9024 12.6834 11.9024 13.3166 12.2929 13.7071L13.7071 12.2929ZM13.7071 19.7071L19.7071 13.7071L18.2929 12.2929L12.2929 18.2929L13.7071 19.7071ZM19.7071 18.2929L13.7071 12.2929L12.2929 13.7071L18.2929 19.7071L19.7071 18.2929Z",
		fill: "#BEBEC1"
	})]
});
export default SvgNoIcon;
